<template>
    <div class="container mt-3">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-success" v-if="copied">Текст скопирован</div>
                                <div class="card-title">Ваш секретный ключ для интеграции с API</div>
                            </div>

                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="Секретный ключ" readonly="true" v-model="secretKey" ref="copyText" />
                                    <div class="input-group-append">
                                        <button @click="copyToClipboard" class="btn btn-secondary" type="button" id="button-addon2"><i class="fa fa-copy mr-1"></i> Скопировать</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="/api/Tarlan%20Payments%20API%20Payin.pdf">Tarlan Payments API Прием оплаты</a><br />
                        <a href="/api/Tarlan%20Payments%20API%20Payout.pdf">Tarlan Payments API Выплаты</a>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "SettingsApi",
        data() {
            return {
                copied: false
            }
        },
        computed: {
            ...mapState({
                secretKey: state => state.merchant.secret_key
            })
        },
        methods: {
            copyToClipboard() {
                this.$refs.copyText.select();

                document.execCommand("Copy");

                this.copied = true
            }
        }
    }
</script>
